var pug = require("!./../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Math, categories, category, randomId) {categories = ['banana', 'apple', 'susi'];
pug_html = pug_html + "\u003Cdiv class=\"wrapper\"\u003E\u003Ch1\u003Eパネル型のカテゴライズ支援\u003C\u002Fh1\u003E\u003Cdiv class=\"content-wrapper\"\u003E\u003Cdiv class=\"panels\"\u003E";
for(var i=0; i <= 19; i++ )
{
randomId = Math.floor(Math.random(1)*10)%3;
category = categories[randomId];
pug_html = pug_html + "\u003Cdiv" + (" class=\"panel js-panel\""+pug.attr("data-category", category, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = category) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"categories" in locals_for_with?locals_for_with.categories:typeof categories!=="undefined"?categories:undefined,"category" in locals_for_with?locals_for_with.category:typeof category!=="undefined"?category:undefined,"randomId" in locals_for_with?locals_for_with.randomId:typeof randomId!=="undefined"?randomId:undefined));;return pug_html;};
module.exports = template;


/*****************
 ** WEBPACK FOOTER
 ** ./app/posts/idea03.pug
 ** module id = 185
 ** module chunks = 0
 **/